import React, { Fragment, useContext, useEffect, useState } from "react";
import { CamelCaseWithSpaces, Camelcase, LogInSchoolID, LogInUserID, escapeCsv, formatDateToMMDDYYYY, formatDateToUsaMMDDYYYY, getTypeWatchDelay, getUrlParameter, transformNameOfCol, typewatch } from "../../JS/Common";
import { ApiGetCall, ApiGetHeaders } from "../../JS/Connector";
import { DeviceDetailsPopup } from "../../Components/DeviceDetailsPopup";
import TicketDetailsPopup from "../../Components/TicketDetailsPopup";
import TicketStatuspopup from "../../Components/TicketStatuspopup";
import { useLocation, useNavigate } from "react-router-dom";
import TicketStatusDropdown from "../../Components/TicketStatusDropdown";
import Pagination from "react-js-pagination";
import CustomizationPopup from "../../Components/CustomizationPopup";
import UserDetailsPopup from "../../Components/UserDetailsPopup";
import AlertsComp from "../../Components/AlertsComp";
import { UserContext } from "../../App";
import PageHead from "../../Components/PageHead";
import Tab from "../../Components/Tab";
import { log } from "../../JS/Logger";
import { hasRoleAccess, RoleEnum } from "../../JS/RoleType";
import useConfig from "../../Hooks/useConfig";
import { useGetCustomFieldsName, useStickyAction } from "../../Hooks";
import CustomFieldInfoIcon from "../../Components/CustomFieldInfoIcon";

export function ManageTicket() {
  const { is_enterprise, department, show_device_complete_club, show_coverage_end_date,
    dcc_module_text, short_form_dcc } = useConfig();
  const [schoolHaveClub, setschoolHaveClub] = useState(0);
  const [TicketTabs, setTicketTabs] = useState({
    OpenTicket: "active",
    AllTicket: "",
    CloseTicket: "",
    PendingTicket: "",
  });
  const [TicketParams, setTicketParams] = useState({
    ticketTabFlag: 1,
    Sortbykey: "",
    SortbyFlag: "desc",
    inventoryId: "",
    ticketId: "",
    lonerFlag: "",
  });
  const [searchString, setSearchString] = useState({
    SearchForOpen: "",
    SearchForClose: "",
    SearchForAll: "",
    SearchForPending: "",
  });
  const [GridData, setGridData] = useState([]);
  const [isModal, setisModal] = useState({
    isshowpopup: false,
    isTicketDetailspopup: false,
    isTicketStatuspopup: false,
    IsDropdownStatusVisible: false,
    TicketStatusId: ''
  });
  const [noteVisibility, setNoteVisibility] = useState({});
  const [selectedIds, setSelectedIds] = useState([]);
  const [loading, setLoading] = useState(false);
  const [CustomizationModal, setCustomizationModal] = useState(false)
  const [columnNames, setColumnNames] = useState([]);
  const showPagination = GridData.length > 0;
  const [currentPage, setCurrentPage] = useState(1);
  const [pageRangeCount, setpageRangeCount] = useState(0);
  const [LimitForPagination, setLimitForPagination] = useState(25);
  const [UserModal, setUserModal] = useState(false)
  const [Userid, setUserid] = useState('');
  const navigate = useNavigate();
  const [lonerFlagCount, setLonerFlagCount] = useState(0);
  const [alert, setAlert] = useState('')
  const [Skey, setSKey] = useState('')
  const [CustomFieldNames, setCustomFieldNames] = useState([]);
  const [selectAllFlag, setSelectAllFlag] = useState(0)
  const { UserData } = useContext(UserContext);
  const effectiveRole = UserData.copyrole || UserData.role || null;
  var MoreTicketFlag = getUrlParameter("flag");
  const isAllSelected =
    TicketParams.ticketTabFlag == 1 || TicketParams.ticketTabFlag == 4
      ? selectedIds.length == GridData.filter((item) => item.StatusID !== 11 && item.StatusID !== 12 && item.StatusID !== 13 && item.StatusID !== 15 && item.StatusID !== 16 && item.StatusID !== 17).length
      : selectedIds.length == GridData.length;

  const location = useLocation();
  const TicketIdFromCreateTicket = location.state && location.state.ticketid;
  const ExcludeVar = !hasRoleAccess(effectiveRole, RoleEnum.ONLY_VAR);
  const { tableWrapperRef, isOverflowing } = useStickyAction(columnNames);
  const { AllCustomFieldNamesColor } = useGetCustomFieldsName();

  useEffect(() => {
    const isAlertShownInHistory = window.history.state && window.history.state.alertShown;
    if (TicketIdFromCreateTicket != null && !isAlertShownInHistory) {
      setAlert(<AlertsComp show={true} variant="success" msg={`Ticket (${TicketIdFromCreateTicket}) Created Successfully`} />);
      window.history.pushState({ alertShown: true }, '');
      setTimeout(function () {
        setAlert(<AlertsComp show={false} />);
      }, 5000);
    }
  }, [TicketIdFromCreateTicket]);
  useEffect(() => {
    AllCustomFieldNamesColor(setCustomFieldNames, true);
    ApiGetHeaders(41, setColumnNames)
  }, []);
  useEffect(() => {
    if (TicketTabs.OpenTicket == 'active') {
      GetGridData(1, searchString.SearchForOpen || null, Skey ? Skey : null, null, 1);
    } else if (TicketTabs.CloseTicket == 'active') {
      GetGridData(2, searchString.SearchForClose || null, Skey ? Skey : null, null, 1);
    } else if (TicketTabs.PendingTicket == 'active') {
      GetGridData(3, searchString.SearchForPending || null, Skey ? Skey : null, null, 1);
    } else {
      GetGridData(4, searchString.SearchForAll || null, Skey ? Skey : null, null, 1);
    }
    if (MoreTicketFlag == 1) {
      setTicketTabs({ ...TicketTabs, PendingTicket: "active", AllTicket: "", CloseTicket: "", OpenTicket: "", });
      GetGridData(3, null, Skey ? Skey : null, null, 1);
    }
  }, [currentPage, LimitForPagination]);
  useEffect(() => {
    if (selectedIds.length == 0) {
      setisModal({ ...isModal, IsDropdownStatusVisible: false });
    }
  }, [selectedIds])
  useEffect(() => {
    if (selectAllFlag) {
      setSelectedIds(GridData.map((item) => item.id));
    }
  }, [GridData, selectAllFlag]);

  async function GetGridData(flag, SearchString, skey, allticketsearchflag, paginationflag) {
    SearchString = SearchString || null;
    if (paginationflag == 1) {
      if (skey) TicketParams.SortbyFlag = TicketParams.SortbyFlag;
    } else {
      if (skey) TicketParams.SortbyFlag = TicketParams.SortbyFlag == "asc" ? "desc" : "asc";
    }
    typewatch(async function () {
      setLoading(true);
      await ApiGetCall(`/tickets?schoolId=${LogInSchoolID}&gridFlag=${flag}&search=${SearchString}&flag=${allticketsearchflag}&sortBy=${(skey || 'id')}&sortOrder=${TicketParams.SortbyFlag}&userId=${LogInUserID}&page=${currentPage}&perPage=${LimitForPagination}`).then((result) => {
        if (result == undefined || result == "") {
          alert("Something went wrong");
        } else {
          setLoading(false);
          const responseRs = JSON.parse(result);
          setpageRangeCount(responseRs?.total);
          setschoolHaveClub(responseRs?.school_have_club);
          setGridData(responseRs?.tickets?.length ? responseRs.tickets : [])
        }
      });
    }, getTypeWatchDelay(SearchString, 1000));
  }

  async function ExportTicketsData(flag) {
    setLoading(true);

    setTimeout(() => {
      setLoading(false);
      setAlert(<AlertsComp show={true} variant="success" msg={`You will receive an email notification once matching data is found and processed.`} />);
    }, 2000);

    setTimeout(() => {
      setAlert(<AlertsComp show={false} />);
    }, 5000);

    setTimeout(() => {
      ApiGetCall(`/tickets/export?schoolId=${LogInSchoolID}&flag=${flag}`)
    }, 0);
  }
  function handleArrowClick(ticketId) {
    setNoteVisibility((prevState) => ({
      ...prevState,
      [ticketId]: !prevState[ticketId],
    }));
  }

  function handleHeaderCheckboxChange(e) {
    const isChecked = e.target.checked;
    if (selectAllFlag == 1) return;
    let updatedSelectedIds;
    if (isChecked) {
      const filteredData = GridData.filter(item => item.StatusID !== 11 && item.StatusID !== 12 && item.StatusID !== 13 && item.StatusID !== 15 && item.StatusID !== 16 && item.StatusID !== 17);
      updatedSelectedIds = filteredData.map(item => item.id);
      setSelectedIds(updatedSelectedIds);
      setisModal({ ...isModal, IsDropdownStatusVisible: true });
    } else {
      setSelectedIds([]);
      setisModal({ ...isModal, IsDropdownStatusVisible: false });
      updatedSelectedIds = [];
    }
    const lonerFlagCount = updatedSelectedIds.reduce((count, id) => {
      const selectedItem = GridData.find(item => item.id === id);
      return selectedItem && selectedItem.loaner_flag === 'yes' ? count + 1 : count;
    }, 0);
    setLonerFlagCount(lonerFlagCount);
  }

  function handleCheckboxChange(e, id, item) {
    const isChecked = e.target.checked;
    if (selectAllFlag == 1) return;
    if (isChecked) {
      setSelectedIds((prevIds) => [...prevIds, id]);
      setisModal({ ...isModal, IsDropdownStatusVisible: true });
      if (item && item.loaner_flag === 'yes') {
        setLonerFlagCount((prevCount) => prevCount + 1);
      }
    } else {
      setSelectedIds((prevIds) =>
        prevIds.filter((selectedId) => selectedId !== id)
      );
      if (item && item.loaner_flag === 'yes') {
        setLonerFlagCount((prevCount) => Math.max(prevCount - 1, 0));
      }
    }
  }
  async function print() {
    setLoading(true);
    ApiGetCall(`/tickets/closed-pdf?schoolId=${LogInSchoolID}&userId=${LogInUserID}`).then((result) => {
      // if (result == undefined || result == "") {
      //   alert("Something went wrong");
      // } else {
      //   setLoading(false);
      //   if (result == "success") {
      //     setAlert(<AlertsComp show={true} variant="success" msg={`The PDF has been successfully sent via email : ${UserData.emailid}`} />);
      //     setTimeout(function () {
      //       setAlert(<AlertsComp show={false} />)
      //     }, 7000);
      //   }
      // }
    });
    setLoading(false);
    setAlert(<AlertsComp show={true} variant="success" msg={`The PDF has been successfully sent via email : ${UserData.emailid}`} />);
    setTimeout(function () {
      setAlert(<AlertsComp show={false} />)
    }, 7000);
  }
  function RepairdetailsScreen(TicketID, FlagParent) {
    setTicketParams({ ...TicketParams, ticketId: TicketID, });
    var tabTicketId = TicketID
    var ticketTabFlag = TicketParams.ticketTabFlag
    var workedonflag = 0
    var parentalCoverageFlag = FlagParent
    navigate('/repair-details', { state: { tabTicketId, ticketTabFlag, workedonflag, parentalCoverageFlag } });
  }
  const handleSortClick = (item) => {
    setSKey(item)
    if (TicketTabs.OpenTicket == 'active') {
      GetGridData(TicketParams.ticketTabFlag, searchString.SearchForOpen, item, null, 0)
    } else if (TicketTabs.CloseTicket == 'active') {
      GetGridData(TicketParams.ticketTabFlag, searchString.SearchForClose, item, null, 0)
    } else if (TicketTabs.PendingTicket == 'active') {
      GetGridData(TicketParams.ticketTabFlag, searchString.SearchForPending, item, null, 0)
    } else {
      GetGridData(TicketParams.ticketTabFlag, searchString.SearchForAll, item, null, 0)
    }
  };
  function renderContentForColumn(columnName, item) {
    const contentMap = {
      "ticket_num": <span
        className="cursor-pointer"
        title="Show Ticket Details"
        onClick={(e) => {
          setisModal({ ...isModal, isTicketDetailspopup: true });
          setTicketParams({ ...TicketParams, ticketId: item.id, inventoryId: item.inventory_id });
        }}
      >
        <u>{item.ticket_num || '-'}</u>
      </span>,
      "Serial_number": <span
        className="cursor-pointer"
        title="Show Device Details"
        style={{ color: item?.activecoveragetypecolor }}
        onClick={(e) => {
          setisModal({ ...isModal, isshowpopup: true });
          setTicketParams({ ...TicketParams, inventoryId: item.inventory_id, ticketId: item.id });
        }}
      >
        <u>{item.serial_num || "-"}</u>
      </span>,
      "User": item?.studentname ?
        <u onClick={(e) => { setUserid(item?.student_id); setUserModal(true) }} title="Show User Details" className="cursor-pointer">{item?.studentname}</u>
        : '-',
      "return_location": item.return_location_name || '-',
      "created_at": item.created_at ? formatDateToUsaMMDDYYYY(item.created_at) : "-",
      "created_by": item.ticket_created_by || "-",
      "parts_total": item.subtotal ? `$${item.subtotal}` : "$0",
      "Device_model": item.device_model || "-",
      "asset_tag": item.asset_tag || "-",
      "Grade": item.grade || "-",
      "Parent_Guardian_Email": item.parent_guardian_email || "-",
      "Parent_phone_number": item.parent_phone_number || "-",
      "Parent_guardian_name": item.parent_guardian_name || "-",
      "Device_complete_club": item.parental_coverage == "1" ? "Yes" : "No",
      "Student_num": item.student_num || "-",
    };
    return contentMap[columnName] || null;
  }
  function handleSearchChange(e) {
    setCurrentPage(1);
    let searchKey = e.target.value;
    let tabFlag = TicketParams.ticketTabFlag;
    GetGridData(tabFlag, searchKey, null, null, 0);
    let searchStringKey = tabFlag == 1 ? 'SearchForOpen' :
      tabFlag == 2 ? 'SearchForClose' :
        tabFlag == 3 ? 'SearchForPending' :
          'SearchForAll';

    setSearchString({ ...searchString, [searchStringKey]: searchKey });
  }
  function handleTabClick(tabType) {
    if (tabType == "open") {
      setTicketTabs({ ...TicketTabs, OpenTicket: "active", AllTicket: "", CloseTicket: "", PendingTicket: "", });
      setTicketParams({ ...TicketParams, ticketTabFlag: 1 });
      GetGridData(1, null, null, null, 0);
      setisModal({ ...isModal, IsDropdownStatusVisible: false });
      setSelectedIds([]);
      setSelectAllFlag(0);
      setSearchString({ ...searchString, SearchForOpen: "", SearchForClose: "", SearchForPending: "", SearchForAll: "" });
      setCurrentPage(1);
      setSKey('')
      setNoteVisibility({});
    } else if (tabType == "close") {
      setTicketTabs({ ...TicketTabs, OpenTicket: "", AllTicket: "", CloseTicket: "active", PendingTicket: "", });
      setTicketParams({ ...TicketParams, ticketTabFlag: 2 });
      GetGridData(2, null, null, null, 0);
      setisModal({ ...isModal, IsDropdownStatusVisible: false });
      setSelectedIds([]);
      setSelectAllFlag(0);
      setSearchString({ ...searchString, SearchForOpen: "", SearchForClose: "", SearchForPending: "", SearchForAll: "" });
      setCurrentPage(1);
      setSKey('');
      setNoteVisibility({});
    } else if (tabType == "repaired") {
      setTicketTabs({ ...TicketTabs, OpenTicket: "", AllTicket: "", CloseTicket: "", PendingTicket: "active", });
      setTicketParams({ ...TicketParams, ticketTabFlag: 3 });
      GetGridData(3, null, null, null, 0);
      setisModal({ ...isModal, IsDropdownStatusVisible: false });
      setSelectedIds([]);
      setSelectAllFlag(0);
      setSearchString({ ...searchString, SearchForOpen: "", SearchForClose: "", SearchForPending: "", SearchForAll: "" });
      setCurrentPage(1);
      setSKey('');
      setNoteVisibility({});
    } else if (tabType == "all") {
      setTicketTabs({ ...TicketTabs, OpenTicket: "", AllTicket: "active", CloseTicket: "", PendingTicket: "", });
      setTicketParams({ ...TicketParams, ticketTabFlag: 4 });
      GetGridData(4, null, null, null, 0);
      setisModal({ ...isModal, IsDropdownStatusVisible: false });
      setSelectedIds([]);
      setSelectAllFlag(0);
      setSearchString({ ...searchString, SearchForOpen: "", SearchForClose: "", SearchForPending: "", SearchForAll: "" });
      setCurrentPage(1);
      setSKey('');
      setNoteVisibility({});
    }
  }
  const handleSelectAll = (e) => {
    const isChecked = e.target.checked;
    setSelectAllFlag(isChecked ? 1 : 0);

    if (isChecked) {
      const filteredIds = GridData.filter(item => item.ticket_status !== 11 && item.ticket_status !== 12 && item.ticket_status !== 13 && item.ticket_status !== 15 && item.ticket_status !== 16 && item.ticket_status !== 17).map(item => item.id);
      setSelectedIds(filteredIds);
      setisModal({ ...isModal, IsDropdownStatusVisible: true });
    } else {
      // Deselect all
      setSelectedIds([]);
      setisModal({ ...isModal, IsDropdownStatusVisible: false });

    }
  };

  return (
    <Fragment>
      <PageHead LimitForPagination={LimitForPagination} setLimitForPagination={setLimitForPagination}
        setCurrentPage={setCurrentPage} heading={"Manage Tickets"} handleSearch={handleSearchChange}
        loading={loading} Alerts={alert} showsearch={true} />
      <div className='row my-2 d-flex justify-content-between pe-0 align-items-center'>
        <div className='col-md-12 ms-2 ps-0 text-center d-md-flex justify-content-end align-items-end'>
          {!hasRoleAccess(effectiveRole, RoleEnum.ONLY_REPAIR_TECH) && TicketTabs.CloseTicket == "active" && GridData.length != 0 ?
            <label className="BorderBtn text-center" onClick={print} title="Export Closed Tickets History">
              Export Closed Tickets History
              <img src="/images/ExportInventory.svg" className="img-fluid ps-2" />
            </label>
            :
            <></>
          }
          {!hasRoleAccess(effectiveRole, RoleEnum.ONLY_REPAIR_TECH) && GridData.length != 0 ? (
            <div className="mx-2 text-center row pe-0" title="Export CSV For Tickets">
              <div className="BlackFont BorderBtn" onClick={(e) => ExportTicketsData(TicketTabs.OpenTicket == 'active' ? 1 : TicketTabs.CloseTicket == 'active' ? 2 : TicketTabs.PendingTicket == 'active' ? 3 : 4)}>
                {TicketTabs.OpenTicket == 'active' ?
                  "Export Open Tickets CSV" :
                  TicketTabs.CloseTicket == 'active' ?
                    "Export Closed Tickets CSV " :
                    TicketTabs.PendingTicket == 'active' ?
                      "Export Repaired Tickets CSV" :
                      "Export All Tickets CSV"
                }
                <img src="/images/ExportInventory.svg" className="img-fluid ps-2" />
              </div>
            </div>
          ) : (
            <div className="col-md-4 text-center row pe-0"></div>
          )}
          <label className="BorderBtn mx-2 text-center" title="Create Ticket" onClick={() => navigate("/create-ticket", { replace: true, state: { CreateTicketNext: 1 } })}>
            Create Ticket
            <img src="/images/AddInventory.svg" className="img-fluid ps-2" />
          </label>
        </div>
      </div>
      <div className="GridBox mt-2 p-3">
        <div className="row align-items-center">
          <div className="col-md-9 px-0">
            <ul className="nav nav-tabs px-3">
              <Tab isActive={TicketTabs.OpenTicket == 'active'}
                label="Open Tickets" onClick={() => handleTabClick('open')} col={'col-md-3'} />
              <Tab isActive={TicketTabs.PendingTicket == 'active'}
                label="Repaired Tickets" onClick={() => handleTabClick('repaired')} col={'col-md-3'} />
              <Tab isActive={TicketTabs.CloseTicket == 'active'}
                label="Closed Tickets" onClick={() => handleTabClick('close')} col={'col-md-3'} />
              <Tab isActive={TicketTabs.AllTicket == 'active'}
                label="All Tickets" onClick={() => handleTabClick('all')} col={'col-md-2'} />
            </ul>
          </div>
          <div className="col-md-3">
            {isModal.IsDropdownStatusVisible == true && (
              <TicketStatusDropdown selectedIds={selectedIds} GetGridData={GetGridData} GridFlag={TicketParams.ticketTabFlag} SelectAllFlag={selectAllFlag}
                ClosePopup={(e) => setisModal({ ...isModal, IsDropdownStatusVisible: false })} setSelectedIds={setSelectedIds} lonerFlagCount={lonerFlagCount}
                setSelectAllFlag={setSelectAllFlag} searchString={searchString} />
            )}
          </div>
        </div>
        <div className="row mt-2 px-3">
          <div className="col-md-6 col-12">
            {hasRoleAccess(effectiveRole, RoleEnum.EXCLUDE_SCH_REPAIR_TECH) &&
              selectedIds.length > 0 &&
              <div className="col-12 fw-600">
                <input className="form-check-input cursor-pointer mt-1 me-2" type="checkbox" name="selectall"
                  checked={selectAllFlag == 1} onChange={handleSelectAll} />
                Select All {TicketTabs.OpenTicket == 'active' ?
                  "Open" :
                  TicketTabs.CloseTicket == 'active' ?
                    "Closed" :
                    TicketTabs.PendingTicket == 'active' ?
                      "Repaired" : null} Tickets
              </div>
            }
          </div>
          <div className="col-md-6 highlight-part  font-12 pb-2 col-12 text-end">
            {ExcludeVar && show_device_complete_club ?
              schoolHaveClub == 1 &&
              `*${dcc_module_text} Ending Soon`
              : null
            }
          </div>
          <div className="greyBox">
            <div className="data-table-container" ref={tableWrapperRef}>
              <table className="table data-table mb-0">
                <thead className="GridHeader">
                  <tr>
                    <th scope="col">
                      {TicketTabs.AllTicket != 'active' && GridData.length !== 0 && GridData.some(item => item.ticket_status !== 11 && item.ticket_status !== 12 && item.ticket_status !== 13 && item.ticket_status !== 15 && item.ticket_status !== 16 && item.ticket_status !== 17) ?
                        <input disabled={selectAllFlag == 1} className="form-check-input cursor-pointer mt-1" type="checkbox" name="allSelect"
                          checked={isAllSelected || selectAllFlag == 1} onChange={handleHeaderCheckboxChange} /> : <></>}
                    </th>
                    {columnNames?.map((item) => {
                      const columnName = item.replace(/_/g, ' ');
                      const transformedName = transformNameOfCol(columnName);
                      if (!transformedName) return null;
                      return columnName != 'Parent phone number' && columnName != dcc_module_text && columnName != 'parts total' ?
                        <th key={item} scope="col" className={`cursor-pointer fw-600 ${item == 'Serial_number' ? 'overflow-visible' : ''}`} title={item == 'Student_num' ? "Sort by User ID" : `Sort by ${CamelCaseWithSpaces(transformedName)}`} onClick={(e) => handleSortClick(item)}>
                          {item == 'Student_num' ? 'User ID' : CamelCaseWithSpaces(transformedName)}
                          <img src="/images/sortbynew.svg" alt={`Sort by ${transformedName}`} className="img-fluid ps-2 sortbyClass" />
                          {GridData.length != 0 && item == 'Serial_number' && (
                            <CustomFieldInfoIcon CustomFieldNames={CustomFieldNames} />
                          )}
                        </th>
                        :
                        <th key={item} scope="col" className='fw-600'>
                          {item == 'Student_num' ? 'User ID' : CamelCaseWithSpaces(transformedName)}
                        </th>
                    })}
                    {(TicketTabs.CloseTicket == 'active' || TicketTabs.AllTicket == 'active') &&
                      <th scope="col" className='cursor-pointer fw-600' title="Sort by Who Closed" onClick={(e) => handleSortClick('who_closed')}>
                        Who Closed
                        <img src="/images/sortbynew.svg" alt="Sort by Who Closed" className="img-fluid ps-2 sortbyClass" />
                      </th>
                    }
                    {TicketTabs.OpenTicket != 'active' &&
                      <th scope="col" className='cursor-pointer fw-600' title="Sort by Who Mark As Billed" onClick={(e) => handleSortClick('who_markas_billed')}>
                        Who Mark As Billed
                        <img src="/images/sortbynew.svg" alt="Sort by Who Mark as Billed" className="img-fluid ps-2 sortbyClass" />
                      </th>
                    }
                    {ExcludeVar && show_device_complete_club ?
                      schoolHaveClub == 1 &&
                      <th scope="col" className={`${TicketTabs.AllTicket == 'active' ? "cursor-pointer" : ""} fw-600`} title={TicketTabs.AllTicket == 'active' && `Sort by ${short_form_dcc} Expiry Date`} onClick={(e) => { if (TicketTabs.AllTicket == 'active') handleSortClick('dcc_expiry_date') }}>
                        {short_form_dcc} Expire Date
                        {TicketTabs.AllTicket == 'active' && <img src="/images/sortbynew.svg" alt={`Sort by ${short_form_dcc} Expiry Date`} className="img-fluid ps-2 sortbyClass" />}
                      </th>
                      : null
                    }
                    <th scope="col" className={`${TicketTabs.AllTicket == 'active' ? "cursor-pointer" : ""} fw-600`} title={TicketTabs.AllTicket == 'active' && "Sort by Status"} onClick={(e) => { if (TicketTabs.AllTicket === 'active') handleSortClick('status') }}>
                      Status
                      {TicketTabs.AllTicket == 'active' && <img src="/images/sortbynew.svg" alt="Sort by Status" className="img-fluid ps-2 sortbyClass" />}
                    </th>
                    <th scope="col" className={`fw-600 ${isOverflowing ? 'sticky-action' : ''}`}>Action
                      <img src="/images/EditHeaderIcon.svg" className="cursor-pointer img-fluid ps-2 pe-5" title='Customize Headers' style={{ height: '25px' }} onClick={(e) => setCustomizationModal(true)} />
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {GridData.length != 0 ? (
                    GridData.map((item, i) => {
                      const isNoteVisible = noteVisibility[item.id];
                      var returData = (
                        <tr key={i} className={`OddEvenClass tableBorderHide ${item.ticket_flag}`} >
                          <td className="py-12">
                            {TicketTabs.AllTicket != 'active' && item.ticket_status != 11 && item.ticket_status != 12 && item.ticket_status !== 13 && item.ticket_status !== 15 && item.ticket_status !== 16 && item.ticket_status !== 17 && (
                              <input type="checkbox" disabled={selectAllFlag == 1} className="form-check-input cursor-pointer" name={item.serial_num} checked={selectedIds.includes(item.id)} onChange={(e) => handleCheckboxChange(e, item.id, item)} />
                            )}
                          </td>
                          {columnNames?.filter(header => !(is_enterprise && header == "Device_complete_club"))?.map(header => (
                            <td className="py-12" key={header}>
                              {renderContentForColumn(header, item)}
                            </td>
                          ))}
                          {(TicketTabs.CloseTicket == 'active' || TicketTabs.AllTicket == 'active') &&
                            <td className="py-12">
                              {item.who_closed || "-"}
                            </td>
                          }
                          {TicketTabs.OpenTicket != 'active' &&
                            <td className="py-12">
                              {item.who_markas_billed || "-"}
                            </td>
                          }
                          {ExcludeVar && show_coverage_end_date ?
                            schoolHaveClub == 1 &&
                            <td className="py-12">
                              {item.student_have_insurance_plan == 1 &&
                                item.coverage_end_flag == 1 ?
                                <label style={{ color: "#e5c20de8" }}> {item.coverage_end_days} Days</label>
                                :
                                <>-</>
                              }
                            </td> : null
                          }
                          <td className="py-12 whitespace">
                            {TicketTabs.AllTicket != 'active' ?
                              <>
                                {item.ticket_status == 11 || item.ticket_status == 12 || item.ticket_status == 13 || item.ticket_status == 15 || item.ticket_status == 16 || item.ticket_status == 17 ?
                                  <span>{item.status?.status}</span> :
                                  <span
                                    className="cursor-pointer"
                                    title="Change Ticket Status"
                                    ticketid={item.id}
                                    onClick={(e) => {
                                      setisModal({ ...isModal, isTicketStatuspopup: true, TicketStatusId: item.status_id });
                                      setTicketParams({ ...TicketParams, lonerFlag: item.loaner_flag, ticketId: item.id });
                                    }}
                                  >
                                    <u>{item.status?.status}</u>
                                  </span>
                                }
                              </>
                              :
                              <>
                                {TicketTabs.AllTicket == 'active' && (<span>{item.status?.status}</span>)}
                              </>}
                          </td>

                          <td className={`py-12 ${isOverflowing ? 'sticky-action' : ''}`}>
                            {ExcludeVar && <img src="/images/EditIconNew.svg" title="Edit Ticket" className="cursor-pointer img-fluid pe-2" ticketid={item.id} onClick={(e) => navigate("/create-ticket/?deviceid=" + item.inventory_id + "&ticketid=" + item.id)} />}
                            <img src="/images/DownRoundArrow.svg" title="Show More Details" className={`cursor-pointer img-fluid ${isNoteVisible ? "d-none" : ""}`} ticketid={item.id} onClick={() => handleArrowClick(item.id)} />
                            <img src="/images/UpRoundArrow.svg" title="Hide More Details" className={`img-fluid cursor-pointer ${isNoteVisible ? "" : "d-none"}`} ticketid={item.id} onClick={() => handleArrowClick(item.id)} />
                            {ExcludeVar && <img src="/images/repairTech.svg" className="px-2 cursor-pointer" title="Add Repair Parts" ticketid={item.id} onClick={(e) => { RepairdetailsScreen(item.id, item.student_have_insurance_plan) }} />}
                          </td>
                        </tr>
                      );
                      if (isNoteVisible) {
                        returData = (
                          <>
                            {returData}
                            <tr className={`col-12  px-5`}>
                              <td colSpan={18}>
                                <b className="font-13 pe-3"> Notes:</b>
                                <div style={{ display: "inline" }}> {item.notes || '-'} </div>
                              </td>
                            </tr>
                            <tr className={`col-12  px-5`}>
                              <td colSpan={18}>
                                <b className="font-13 pe-3">Device Issues:</b>
                                <div style={{ display: "inline" }}> {item.issues.map((item) => item).join(", ")} </div>
                              </td>
                            </tr>
                            <tr className={`col-12  px-5`}>
                              <td colSpan={18}>
                                <b className="font-13 pe-3">Building:</b>
                                <div style={{ display: "inline" }}> {item.building_name || '-'}</div>
                              </td>
                            </tr>
                          </>
                        );
                      }
                      return returData;
                    })
                  ) : (
                    <tr><td colSpan={18} className="p-3 text-center"> No Record Found </td></tr>
                  )}
                </tbody>
              </table>
            </div>
            {showPagination && (
              <Pagination
                activePage={currentPage}
                totalItemsCount={pageRangeCount}
                pageRangeDisplayed={15}
                itemsCountPerPage={LimitForPagination}
                onChange={(page) => {
                  setCurrentPage(page);
                  if (selectAllFlag) {
                    setSelectedIds(GridData.map((item) => item.id));
                  } else {
                    setSelectedIds([])
                  }
                }}
                color="primary"
                lastPageText=""
                firstPageText=""
                itemClassFirst="MasterClass"
                itemClassPrev="MasterClass"
                itemClassNext="MasterClass"
                itemClassLast="MasterClass"
                hideFirstLastPages={true} />
            )}
          </div>
        </div>
      </div>
      {isModal.isshowpopup == true && (
        <DeviceDetailsPopup Showbuttons={1} ticketid={TicketParams.ticketId} createticketbutton={true} deviceid={TicketParams.inventoryId} activetab="device" isShow={isModal.isshowpopup} ClosePopup={(e) => setisModal({ ...isModal, isshowpopup: false })} />
      )}
      {isModal.isTicketDetailspopup == true && (
        <TicketDetailsPopup isShow={isModal.isTicketDetailspopup} ticketid={TicketParams.ticketId} inventoryid={TicketParams.inventoryId} ClosePopup={(e) => setisModal({ ...isModal, isTicketDetailspopup: false })} />
      )}
      {isModal.isTicketStatuspopup == true && (
        <TicketStatuspopup isShow={isModal.isTicketStatuspopup} ClosePopup={(e) => setisModal({ ...isModal, isTicketStatuspopup: false })}
          Lonerflag={TicketParams.lonerFlag}
          TicketId={TicketParams.ticketId}
          GetGridData={GetGridData}
          GridFlag={TicketParams.ticketTabFlag} SelectAllFlag={selectAllFlag}
          clearSearch={(e) => setSearchString({ ...searchString, SearchForOpen: "", SearchForClose: "", SearchForPending: "", SearchForAll: "" })}
          TicketStatusId={isModal.TicketStatusId}
          setSelectedIds={setSelectedIds}
          setSelectAllFlag={setSelectAllFlag}
          searchString={searchString}
        />
      )}
      {CustomizationModal == true && (
        <CustomizationPopup isShow={CustomizationModal} setCustomizationModal={setCustomizationModal} gridname={"Manage Ticket"} GetCall={() => ApiGetHeaders(41, setColumnNames)} />
      )}
      {UserModal == true && (
        <UserDetailsPopup isShow={UserModal} ClosePopup={(e) => setUserModal(false)} userid={Userid} />
      )}
    </Fragment>
  );
}